import { Component } from '@angular/core';

@Component({
  selector: 'app-ef-data',
  templateUrl: './ef-data.component.html',
  styleUrls: ['./ef-data.component.css']
})
export class EFDataComponent {
}